import api from 'api'
import { VerificationType } from 'types/verificationTypes'

export type PositionRequirementRow = {
  id: number
  name: string
  category: string
  credential?: string | null
  verifiable: boolean
  isWorkerVisible: boolean
  verificationType: VerificationType
}

type RequirementDataForPositionBody = {
  data: {
    admin: {
      positions: Array<{
        requirements2: PositionRequirementRow[] | null
        mustHaveRequirements: Array<{ id: number }>
      }>
    }
  }
}

/**
 * Get requirements attached to a position plus must-have flags.
 */
export async function getRequirementDataForPosition(positionId: number) {
  const response = await api.post<RequirementDataForPositionBody>(
    '/admin/graphql_dispatch/requirement_data_74f78cd1',
    { positionId }
  )
  return response.data
}
